import { useState } from "react";
import { useLanding } from "@/context/LandingContext";
import { InteractiveSection, MotionBg } from "./MotionBg";
import { Reveal } from "./Reveal";

export function WholePlan() {
  const { t } = useLanding();
  const [active, setActive] = useState(0);
  const tabs = t.plan.tabs;
  const panel = tabs[active];

  const onKeyDown = (event, index) => {
    if (!["ArrowLeft", "ArrowRight"].includes(event.key)) return;
    event.preventDefault();
    const next = event.key === "ArrowRight" ? (index + 1) % tabs.length : (index - 1 + tabs.length) % tabs.length;
    setActive(next);
    document.getElementById(`plan-tab-${next}`)?.focus();
  };

  return (
    <InteractiveSection className="section" id="learn" data-testid="plan-section">
      <MotionBg variant="orbits" dots={2} />
      <div className="container whole-plan-grid">
        <Reveal className="sticky-copy">
          <p className="eyebrow"><span className="eyebrow-no">02</span>{t.plan.eyebrow}</p>
          <h2>{t.plan.title}</h2>
          <p className="subhead">{t.plan.lead}</p>
        </Reveal>
        <Reveal className="planning-shell" delay={0.1}>
          <div className="planning-tabs" role="tablist" aria-label="Legacy planning topics">
            {tabs.map((tab, index) => (
              <button
                key={tab.label}
                id={`plan-tab-${index}`}
                type="button"
                role="tab"
                className={`plan-tab ${active === index ? "active" : ""}`}
                aria-selected={active === index}
                aria-controls={`plan-panel-${index}`}
                tabIndex={active === index ? 0 : -1}
                onClick={() => setActive(index)}
                onKeyDown={(event) => onKeyDown(event, index)}
                data-testid={`plan-tab-${index}`}
              >
                <span>0{index + 1}</span>
                {tab.label}
              </button>
            ))}
          </div>
          <div className="plan-content">
            <div className="plan-panel" key={active} id={`plan-panel-${active}`} role="tabpanel" aria-labelledby={`plan-tab-${active}`} data-testid={`plan-panel-${active}`}>
              <span className="panel-label">{panel.panelLabel}</span>
              <h3>{panel.title}</h3>
              <p>{panel.copy}</p>
              <a className="source-link" href={panel.href} target="_blank" rel="noopener noreferrer">
                {panel.source} <span>↗</span>
              </a>
              <div className="panel-prompt">
                <strong>{t.plan.askYourself}</strong> {panel.prompt}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </InteractiveSection>
  );
}
